import { render, staticRenderFns } from "./DialogResource.vue?vue&type=template&id=06504868&"
import script from "./DialogResource.vue?vue&type=script&lang=js&"
export * from "./DialogResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports